class AnalyticsController {
  constructor(AnalyticsService, $q) {
    "ngInject"

    this.analyticsService = AnalyticsService;
    this.$q = $q;
  }

  $onInit() {
    this.isLoading = true;

    const revenuePromise = this.analyticsService.getRevenueData();
    const payingCustomersPromise = this.analyticsService.getPayingCustomersData();
    const jobsSuccessRatePromise = this.analyticsService.getJobsSuccessRateData();
    const registrationsOvertimePromise = this.analyticsService.getRegistrationsOverTimeData();
    const recentRegistrationsPromise = this.analyticsService.getRecentRegistrationsData();
    const customerRedemptionsOverTimePromise = this.analyticsService.getCustomerRedemptionsOverTime();
    const accountApprovalOverTimePromise = this.analyticsService.getAccountApprovalOverTime();
    const newVersusRecurringRevenuePromise = this.analyticsService.getNewVersusRecurringRevenueData();
    const getGeneralStatsPromise = this.analyticsService.getGeneralStatsData();
    const clientProfileItemsPerYearPromise = this.analyticsService.getClientProfileItemsPerYearData();
    const providerProfileItemsPerYearPromise = this.analyticsService.getProviderProfileItemsPerYearData();
    const getNSWRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getNSWRegistrationsByRegionOverTimeData();
    const getVICRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getVICRegistrationsByRegionOverTimeData();
    const getJobValueOverTimePromise = this.analyticsService.getJobValueOverTimeData();
    const getBotStatsPromise = this.analyticsService.getBotStatsData();
    const getDataSetsPromise = this.analyticsService.getDataSets();


    this.$q.all([revenuePromise, payingCustomersPromise, jobsSuccessRatePromise, registrationsOvertimePromise, recentRegistrationsPromise, customerRedemptionsOverTimePromise, accountApprovalOverTimePromise, newVersusRecurringRevenuePromise, getGeneralStatsPromise, clientProfileItemsPerYearPromise, providerProfileItemsPerYearPromise, getNSWRegistrationsByRegionOverTimeDataPromise, getVICRegistrationsByRegionOverTimeDataPromise, getJobValueOverTimePromise, getBotStatsPromise, getDataSetsPromise]).then(data => {

      const [ revenueResponse, payingCustomersResponse, jobsSuccessRateResponse, registrationsOvertimeResponse, recentRegistrationsResponse, customerRedemptionsOverTimeResponse, accountApprovalOverTimeResponse, newVersusRecurringRevenueResponse, getGeneralStatsResponse, clientProfileItemsPerYearResponse, providerProfileItemsPerYearResponse, getNSWRegistrationsByRegionOverTimeDataResponse, getVICRegistrationsByRegionOverTimeDataResponse, getJobValueOverTimeResponse, getBotStatsResponse, getdataSetsResponse ] = data;

      this.setRevenueChartOptions(revenueResponse);

      this.setJobValueOverTimeOptions(getJobValueOverTimeResponse);

      this.setJobsSuccessRateChartOptions(jobsSuccessRateResponse);

      this.setRegistrationsOverTimeChartOptions(registrationsOvertimeResponse);

      this.setRecentRegistrationsChartOptions(recentRegistrationsResponse);

      //this.setCustomerRedemptionsOverTimeChartOptions(customerRedemptionsOverTimeResponse);

      //this.setPayingCustomersChartOptions(payingCustomersResponse);

      this.setRedemptionsAndNewPayingCustomersOverTimeOptions(payingCustomersResponse, customerRedemptionsOverTimeResponse);

      this.setAccountApprovalOverTimeOptions(accountApprovalOverTimeResponse);

      this.setNewVersusRecurringRevenueOptions(newVersusRecurringRevenueResponse);

      this.setGeneralStatsOptions(getGeneralStatsResponse);

      this.setBotStatsOptions(getBotStatsResponse);

      this.setClientProfileItemsPerYearOptions(clientProfileItemsPerYearResponse);

      this.setProviderProfileItemsPerYearOptions(providerProfileItemsPerYearResponse);

      this.setRegistrationsByRegionOverTimeChartOptions(getNSWRegistrationsByRegionOverTimeDataResponse, getVICRegistrationsByRegionOverTimeDataResponse);

      this.setDataSetsOptions(getdataSetsResponse);

      this.isLoading = false;
    })

  }

  setRevenueChartOptions(data) {
    var format = "{0:C}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    var totalRevenueSeries = [];
    totalRevenueSeries.push(data.series[0]);
    totalRevenueSeries.push(data.series[2]);
    totalRevenueSeries.push(data.series[3]);
    totalRevenueSeries.push(data.series[1]);

     this.totalRevenueChartOptions = this.analyticsService.getChartOptions("Revenue Breakdown", totalRevenueSeries, data.categories, format, template, dateFormat);

    // var paygSeries = [];
    // paygSeries.push(data.series[2]);
    // paygSeries.push(data.series[3]);

    // this.paygChartOptions = this.getChartOptions("PAYG Revenue", paygSeries, data.categories, format, template, dateFormat);

    // var plansSeries = [];
    // plansSeries.push(data.series[4]);
    // plansSeries.push(data.series[5]);

    // this.plansChartOptions = this.getChartOptions("Plans Revenue", plansSeries, data.categories, format, template, dateFormat);
  }

  setJobValueOverTimeOptions(data) {
    var format = "{0:C}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

     this.jobValueOverTimeChartOptions = this.analyticsService.getChartOptions("Total Jobs Value", data.series, data.categories, format, template, dateFormat);
  }

  setNewVersusRecurringRevenueOptions(data) {
    var format = "{0:C}";
    var template = "#: text # - TRX: #: series.totalCount #, Total: #: kendo.toString(series.totalRevenue, 'C0') #";
    var dateFormat = {months: "MMM 'yy"};

    var totalRevenueSeries = [];
    totalRevenueSeries.push(data.series[0]);
    totalRevenueSeries.push(data.series[1]);
    totalRevenueSeries.push(data.series[2]);

    var quarterlyRevenueSeries = [];
    quarterlyRevenueSeries.push(data.series[3]);
    quarterlyRevenueSeries.push(data.series[4]);
    quarterlyRevenueSeries.push(data.series[5]);

    var annualRevenueSeries = [];
    annualRevenueSeries.push(data.series[6]);
    annualRevenueSeries.push(data.series[7]);
    annualRevenueSeries.push(data.series[8]);

    this.newVersusRecurringRevenueOptions = this.analyticsService.getChartOptions("New vs Recurring Revenue", totalRevenueSeries, data.categories, format, template, dateFormat);

    this.newVersusRecurringQuarterlyRevenueOptions = this.analyticsService.getChartOptions("Quarterly Subscriptions - New vs Recurring Revenue", quarterlyRevenueSeries, data.categories, format, template, dateFormat);
    this.newVersusRecurringAnnualRevenueOptions = this.analyticsService.getChartOptions("Annual Subscriptions - New vs Recurring Revenue", annualRevenueSeries, data.categories, format, template, dateFormat);
  }

  // setCustomerRedemptionsOverTimeChartOptions(data) {
  //   var format = "{0}";
  //   var template = "#: text # - Customers: #: series.totalCount #";
  //   var dateFormat = {months: "MMM 'yy"};

  //   this.customerRedemptionsOverTimeOptions = this.getChartOptions("$7.50 Redemptions", data.series, data.categories, format, template, dateFormat);
  // }

  // setPayingCustomersChartOptions(data) {
  //   var format = "{0}";
  //   var template = "#: text # - Customers: #: series.totalCount #";
  //   var dateFormat = {months: "MMM 'yy"};

  //   this.payingCustomersOptions = this.getChartOptions("New Paying Customers", data.series, data.categories, format, template, dateFormat);
  // }

  setRedemptionsAndNewPayingCustomersOverTimeOptions(redemptions, newPayingCustomers) {
      var format = "{0}";
      var template = "#: text # - Customers: #: series.totalCount #";
      var dateFormat = {months: "MMM 'yy"};

      var series = [];
      series.push(newPayingCustomers.series[0]);
      series.push(redemptions.series[0]);

      this.redemptionsAndNewPayingCustomersOverTimeOptions = this.analyticsService.getChartOptions("Redemptions & New Paying Customers", series, redemptions.categories, format, template, dateFormat);
  }

  setRegistrationsOverTimeChartOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {months: "MMM 'yy"};

    this.registrationsOverTimeOptions = this.analyticsService.getChartOptions("Registrations Over Time", data.series, data.categories, format, template, dateFormat);
  }

  setDataSetsOptions(set) {
    this.registrationsOverTimeGridOptions = this.analyticsService.getGridOptions(set[0]);
    this.approvalsAndRedemptionsOverTimeGridOptions = this.analyticsService.getGridOptions(set[1]);
    this.firstTimePayingCustomersGridOptions = this.analyticsService.getGridOptions(set[2]);
    this.recurringPayingCustomersGridOptions = this.analyticsService.getGridOptions(set[3]);
    this.firstTimeQSPayingCustomersGridOptions = this.analyticsService.getGridOptions(set[4]);
    this.firstTimeASPayingCustomersGridOptions = this.analyticsService.getGridOptions(set[5]);
    this.redemptionsGridOptions = this.analyticsService.getGridOptions(set[6]);
  }

  setRegistrationsByRegionOverTimeChartOptions(nswData, vicData) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {months: "MMM 'yy"};

    this.nswRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("NSW Registrations By Region", nswData.series, nswData.categories, format, template, dateFormat);
    this.vicRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("VIC Registrations By Region", vicData.series, vicData.categories, format, template, dateFormat);
  }

  setRecentRegistrationsChartOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {days: "ddd dd"};

    this.recentRegistrationsOptions = this.analyticsService.getChartOptions("Recent Registrations", data.series, data.categories, format, template, dateFormat, null, "days");
  }

  setAccountApprovalOverTimeOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {days: "ddd dd"};

    var parsedCats = data.categories.map( (item) => kendo.toString(new Date(item), "yy-MM"));
    const tooltipTemplate = (e) => {
      var idx = parsedCats.indexOf(kendo.toString(e.category, "yy-MM"));

      var activeSeries = data.series[e.series.index];
      var relatedSeries;
      if (e.series.index < 2)
        relatedSeries = data.series[e.series.index == 0 ? 1 : 0];
      else
        relatedSeries = data.series[e.series.index == 2 ? 3 : 2];
      var relatedItem = relatedSeries.data[idx];
      var total = e.dataItem.value + relatedItem;

      var ratio = kendo.toString(e.dataItem.value / total, "p");
      return ratio;
    };

    this.accountApprovalOverTimeOptions = this.analyticsService.getChartOptions("Pending vs Approved Accounts", data.series, data.categories, format, template, dateFormat, tooltipTemplate);
  }

  setJobsSuccessRateChartOptions(data) {
    var format = "{0:p0}";
    var template = "#: text #";
    var dateFormat = {months: "MMM 'yy"};

    this.jobsSuccessRateoptions = this.analyticsService.getChartOptions("Jobs Success Rate", data.series, data.categories, format, template, dateFormat);
  }

  setGeneralStatsOptions(data) {
    var clientJourneySet = data.series[0];
    this.clientJourneyOptions = this.analyticsService.getFunnelChartOptions(clientJourneySet.name, clientJourneySet.data);

    var providerJourneySet = data.series[1];
    this.providerJourneyOptions = this.analyticsService.getFunnelChartOptions(providerJourneySet.name, providerJourneySet.data);

    var revenueAtGlanceSet = data.series[2];
    var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueAtGlanceSet.name, revenueAtGlanceSet.totalCount, revenueAtGlanceSet.totalRevenue);
    var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
    this.revenueAtGlanceOptions = this.analyticsService.getDonutChartOptions(revenueAtGlanceSet, titleFormat, labelFormat);

    var revenueByFrequencySet = data.series[4];
    var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueByFrequencySet.name, revenueByFrequencySet.totalCount, revenueByFrequencySet.totalRevenue);
    var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
    this.revenueByFrequencyOptions = this.analyticsService.getDonutChartOptions(revenueByFrequencySet, titleFormat, labelFormat);

    var jobDistributionSet = data.series[3];
    titleFormat = kendo.format("{0} - TRX: {1}", jobDistributionSet.name, jobDistributionSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Jobs', dataItem.value)#";
    this.jobDistributionOptions = this.analyticsService.getDonutChartOptions(jobDistributionSet, titleFormat, labelFormat);

    var revenueBySourceSet = data.series[5];
    titleFormat = kendo.format("{0} - Parents: {1}", revenueBySourceSet.name, revenueBySourceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Parents', dataItem.value)#";
    this.revenueBySourceOptions = this.analyticsService.getDonutChartOptions(revenueBySourceSet, titleFormat, labelFormat);

    var redemptionsBySourceSet = data.series[6];
    titleFormat = kendo.format("{0} - Redemptions: {1}", redemptionsBySourceSet.name, redemptionsBySourceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Redemptions', dataItem.value)#";
    this.redemptionsBySourceOptions = this.analyticsService.getDonutChartOptions(redemptionsBySourceSet, titleFormat, labelFormat);

    var jobsByDeviceSet = data.series[7];
    titleFormat = kendo.format("{0} - TRX: {1}", jobsByDeviceSet.name, jobsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Jobs', dataItem.value)#";
    this.jobsByDeviceOptions = this.analyticsService.getDonutChartOptions(jobsByDeviceSet, titleFormat, labelFormat);

    var registrationsByDeviceSet = data.series[8];
    titleFormat = kendo.format("{0} - Registrations: {1}", registrationsByDeviceSet.name, registrationsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Registrations', dataItem.value)#";
    this.registrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(registrationsByDeviceSet, titleFormat, labelFormat);

    var parentRegistrationsByDeviceSet = data.series[9];
    titleFormat = kendo.format("{0} - Registrations: {1}", parentRegistrationsByDeviceSet.name, parentRegistrationsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Registrations', dataItem.value)#";
    this.parentRegistrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(parentRegistrationsByDeviceSet, titleFormat, labelFormat);

    var helperRegistrationsByDeviceSet = data.series[10];
    titleFormat = kendo.format("{0} - Registrations: {1}", helperRegistrationsByDeviceSet.name, helperRegistrationsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Registrations', dataItem.value)#";
    this.helperRegistrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(helperRegistrationsByDeviceSet, titleFormat, labelFormat);
  }

  setBotStatsOptions(data) {
    var eventStats = data.series[0];
    var titleFormat = kendo.format("{0} - Events: {1}", eventStats.name, eventStats.totalCount);
    var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Events', dataItem.value)#";
    this.botEventsOptions = this.analyticsService.getDonutChartOptions(eventStats, titleFormat, labelFormat);
  }

  setClientProfileItemsPerYearOptions(data) {
    this.clientProfileItemsPerYearOptions = this.analyticsService.getColumnChartOptions("Missing Items in Parent Accounts ", data);
  }

  setProviderProfileItemsPerYearOptions(data) {
    this.providerProfileItemsPerYearOptions = this.analyticsService.getColumnChartOptions("Missing Items in Helper Accounts ", data);
  }
}

export default AnalyticsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics/analytics.controller.js
 **/